import Vue from 'vue';

import { globalConfig } from "@/config";

import at from '@/helpers/config/at';
import de from '@/helpers/config/de';

let config = null;

const project = globalConfig.project;
const mode = globalConfig.mode;

if (project === 'hilfy') {
    config = at[mode];
} else {
    config = de[mode];
}

if (mode !== 'dev') {
    config.amplitude = globalConfig.amplitude
}

config.smsToken = globalConfig.smsToken

const key = '$config';
Object.defineProperty(Vue.prototype, key, {
    get() {
        return Object.freeze(config);
    }
});

export default config;